import L from "leaflet";
import Choices from "choices.js";
import loadData from "./loadData";
import initialiseMap from "../../../State-of-Wildfires-Map/src/js/map";
// prettier-ignore
import { colourPolygons, popupContent } from "../../../State-of-Wildfires-Map/src/js/utils";
import "leaflet/dist/leaflet.css";
import "choices.js/public/assets/styles/choices.min.css";

let geojsonArray = [];
let map, geojsonLayer, legend, displayInfo;

// prettier-ignore
const colPalette = ["#C7403D","#D6675E","#E28B81","#EBAEA6","#F1D1CC","#F3F3F3","#ACB0C7","#67729C","#163A72","#163A72"];
const scale = [200, 100, 50, 25, 10, 0, -10, -25, -50];

// Main function to start app
window.addEventListener("load", async () => {
  // Initialise Choices selector instances
  const layer = document.getElementById("layer-selector");
  const variable = document.getElementById("variable-selector");
  const options = {
    searchEnabled: false,
    allowHTML: true,
    shouldSort: false,
    itemSelectText: "click to select",
  };
  const choicesVar = new Choices(variable, options);
  const choicesLayer = new Choices(layer, options);

  // Wait for data to load
  geojsonArray = await loadData();

  // Disable spinner
  document.querySelector(".spinner").style.display = "none";

  // Add name property to each layer
  geojsonArray[0]["name"] = "Countries";
  geojsonArray[1]["name"] = "Continental_Biomes";
  geojsonArray[2]["name"] = "IPCC_WGI_regions";
  geojsonArray[3]["name"] = "GADM_UCDavis_L1";
  // console.log(geojsonArray);

  // Initialise map
  map = initialiseMap("2023-2024");

  // Add default layer to map
  geojsonLayer = L.geoJson(activeLayer(), {
    style: stylePolygons("ba_anom"),
    onEachFeature: onEachFeature,
  }).addTo(map);

  // Inititate legend control
  legend = L.control({ position: "bottomleft" });

  // Function when element is added to map
  legend.onAdd = function (map) {
    const activeVariable = layer.value;
    const unit = "%";
    // console.log(scaleObj[activeVariable]);

    const div = L.DomUtil.create("div", "displayInfo legend"),
      grades = scale,
      labels = scale;

    // Legend title
    div.innerHTML += `
      <span id="legend-title">
        <h6 class="text-start legendTooltip" style="display: none;">% Deviation from the Average Fire Season</h6>
        <h6 class="text-start">
          Key
          <span>(${unit})</span>
        </h6>
      </span>
    `;

    for (let i = 0; i < grades.length - 1; i++) {
      div.innerHTML += `
        <i style="background:${colPalette[i]}"></i>
        <span class="legend-text">${
          grades[i] > 0 ? `+${grades[i]}` : grades[i]
        }</span>
        <br>
      `;
    }

    div.innerHTML += `
      <i style="background:${colPalette[grades.length]}"></i>
      <span class="legend-text">${grades[grades.length - 1]}</span>
    `;

    return div;
  };
  legend.addTo(map);

  // Layer change control
  document.getElementById("layer-selector").addEventListener("change", () => {
    // Remove active layer from map
    map.removeLayer(geojsonLayer);

    // Extract active second selector
    let activeVariable = document.getElementById("variable-selector").value;

    // Add new layer to map
    geojsonLayer = L.geoJson(activeLayer(), {
      style: stylePolygons(activeVariable),
      onEachFeature: onEachFeature,
    }).addTo(map);
  });

  // Variable change control
  document
    .getElementById("variable-selector")
    .addEventListener("change", () => {
      // Remove active layer from map
      map.removeLayer(geojsonLayer);

      // Extract active second selector
      let activeVariable = document.getElementById("variable-selector").value;

      // Add new layer to map
      geojsonLayer = L.geoJson(activeLayer(), {
        style: stylePolygons(activeVariable),
        onEachFeature: onEachFeature,
      }).addTo(map);

      // Change title of displayInfo text content on top-right widget
      // prettier-ignore
      const activeVariableText = document.getElementById("variable-selector").textContent;
      // prettier-ignore
      document.querySelector(".displayInfo > h4").textContent = activeVariableText;
    });

  // Add a custom control to display the region and value on the top-right of the map
  displayInfo = L.control();

  // Text to display when user hovers over polygons (initialise)
  displayInfo.onAdd = function (map) {
    this._div = L.DomUtil.create("div", "displayInfo");
    this._div.setAttribute("id", "display-info-widget");
    this.update();
    return this._div;
  };

  // Text to display when user hovers over polygons (update)
  displayInfo.update = function (property) {
    const element = document.getElementById("variable-selector");
    const text = element.options[element.selectedIndex].text;
    const unit = "%";
    if (property) {
      this._div.innerHTML = `<h4>${text}</h4> <b>${property.reg_name}:
      ${
        property[element.value] !== null
          ? property[element.value] > 0
            ? `+${property[element.value]}`
            : property[element.value]
          : "Insufficient Data"
      }
      ${property[element.value] !== null ? unit : ""}</b>`;
    } else {
      this._div.innerHTML = `<h4>${text}</h4> <span>Hover over a polygon</span>`;
    }
  };
  displayInfo.addTo(map);

  // Additional event listeners
  // prettier-ignore
  document.getElementById("btn-download-data").addEventListener("click", exportCSV);
  attachEventListeners();
});

// ------------------- //
// Styling Functions
// ------------------- //

// Function to find the active layer in the first selector
function activeLayer() {
  const firstSelectorValue = document.getElementById("layer-selector").value;
  const activeLayerIndex = geojsonArray
    .map((arr) => arr.name)
    .indexOf(firstSelectorValue);
  const activeLayerData = geojsonArray[activeLayerIndex];
  return activeLayerData;
}

// Function to style polygons
function stylePolygons(variable) {
  return function (feature) {
    return {
      fillColor: colourPolygons(
        feature.properties[variable],
        variable,
        scale,
        colPalette
      ),
      weight: 0.5,
      opacity: 1,
      color: "black",
      dashArray: "1",
      fillOpacity: 1,
    };
  };
}

// Function to highlight polygon borders and show popup on mouseover (when mouse hovers over them)
function highlightPolygon(e) {
  const polygon = e.target;

  // Polygon borders
  polygon.setStyle({
    weight: 2,
    color: "black",
    fillOpacity: 1,
  });

  // Update display information in top-right box
  displayInfo.update(polygon.feature.properties);

  polygon.bringToFront();
}

// Functions to trigger white and black transition when a polygon is clicked
const triggerWhite = (e) => {
  e.target.setStyle({ color: "white" });
};
const triggerBlack = (e) => {
  e.target.setStyle({ color: "black" });
};

// Popup options
// https://leafletjs.com/reference.html#popup
const popupOptions = {
  className: "popupCustom", // must match a css class
  closeButton: true,
  autoPan: true,
};

// Function to show popup on mouse click
function showPopup(e) {
  const polygon = e.target;

  // Popup content
  const popupContentHtml = popupContent(polygon.feature.properties);

  // Create popup that stays within map boundary
  const popup = L.responsivePopup({ offset: [0, 0] }).setContent(
    popupContentHtml
  );

  // Bind the popup with unique content
  polygon.bindPopup(popup, popupOptions).openPopup();
}

// Function to reset border to original style on mouseout (when mouse is not hovering over a polygon)
function resetHighlight(e) {
  geojsonLayer.resetStyle(e.target);
  displayInfo.update();
}

// Function to add highlighting parameters to a layer
function onEachFeature(feature, layer) {
  layer.on({
    mouseover: highlightPolygon,
    mouseout: resetHighlight,
    click: showPopup,
    mousedown: triggerWhite,
    mouseup: triggerBlack,
  });
}

// Function to attach tooltip event listeners
function attachEventListeners() {
  document
    .querySelector("#legend-title")
    .addEventListener("mouseenter", function () {
      document.querySelector(".legendTooltip").style.display = "flex";
    });

  document
    .querySelector("#legend-title")
    .addEventListener("mouseleave", function () {
      document.querySelector(".legendTooltip").style.display = "none";
    });
}

// Function to download data when download button is clicked
function exportCSV() {
  // 1. Prepare layer data for download
  let csv = "";
  let row = "";

  // Programmatically extract keys from the first object to use as headers
  const keys = Object.keys(activeLayer().features[0].properties);

  // Change order of keys
  const keysOrder = [
    "reg_layer",
    "reg_ID",
    "reg_name",
    "start_yr",
    "end_yr",
    "start_mo",
    "end_mo",
    "land_cov",
  ];

  // Filter out the keys items from the original array
  const remainingItems = keys.filter((item) => !keysOrder.includes(item));

  // Sort the remaining items alphabetically
  remainingItems.sort();

  // Concatenate the keys items with the sorted remaining items
  const keysHeader = keysOrder.concat(remainingItems);

  // Prepare array with new column names based on condition
  let newHeader = keysHeader.map((element) => {
    if (element === "reg_layer") return "Regional Layer";
    if (element === "reg_ID") return "Region ID";
    if (element === "reg_name") return "Region Name";
    if (element === "start_yr") return "Fire Season Start Year";
    if (element === "end_yr") return "Fire Season End Year";
    if (element === "start_mo") return "Fire Season Start Month";
    if (element === "end_mo") return "Fire Season End Month";
    if (element === "land_cov") return "Land Cover";
    if (element === "ba_anom")
      return "Burned Area Anomaly in 2023-24 Fire Season (%)";
    if (element === "ba_final")
      return "Burned Area in 2023-24 Fire Season (km^2)";
    if (element === "ba_mean") return "Burned Area Mean Annual (km^2)";
    if (element === "ba_moAf")
      return "Months After Peak with Above-Average Burned Area";
    if (element === "ba_moBf")
      return "Months Prior to Peak with Above-Average Burned Area";
    if (element === "ba_moPk") return "Month with Peak in Burned Area Anomaly";
    if (element === "ba_rank") return "Burned Area Rank in 2023-24 Fire Season";
    if (element === "cem_emAn")
      return "Carbon Emitted Anomaly in 2023-24 Fire Season (%)";
    if (element === "cem_emFl") return "Carbon Emitted in 2023-24 Fire Season";
    if (element === "cem_emMn") return "Carbon Emitted Mean Annual (kg)";
    if (element === "cem_emRk")
      return "Carbon Emitted Rank in 2023-24 Fire Season";
    if (element === "frp_95dPc")
      return "Average Fire's 95th Percentile FRP Anomaly (%)";
    if (element === "frp_95r")
      return "Average Fire's 95th Percentile FRP Rank (MW)";
    if (element === "cem_moAf")
      return "Months After Peak with Above-Average Carbon Emitted";
    if (element === "cem_moBf")
      return "Months Prior to Peak with Above-Average Carbon Emitted";
    if (element === "cem_moPk")
      return "Month with Peak in Carbon Emitted Anomaly";
    if (element === "gfa_95FAP")
      return "95th Percentile Fire Size Anomaly in 2023-24 Fire Season (%)";
    if (element === "gfa_95FRk")
      return "95th Percentile Fire Size Rank in 2023-24 Fire Season";
    if (element === "gfa_95Fz")
      return "95th Percentile Fire Size in 2023-24 Fire Season (km^2)";
    if (element === "gfa_95RAP")
      return "95th Percentile Rate of Growth Anomaly in 2023-24 Fire Season (%)";
    if (element === "gfa_95RRk")
      return "95th Percentile Rate of Growth Rank in 2023-24 Fire Season";
    if (element === "gfa_95Ros")
      return "95th Percentile Rate of Growth in 2023-24 Fire Season (km^2 day^-1)";
    if (element === "gfa_mxFz")
      return "Maximum Fire Size in 2023-24 Fire Season (km^2)";
    if (element === "gfa_mxRos")
      return "Maximum Rate of Growth in 2023-24 Fire Season (km^2 day^-1)";
    if (element === "gfa_nF")
      return "Number of Fires Rank in 2023-24 Fire Season";
    if (element === "gfa_nFAnP")
      return "Number of Fires Anomaly in 2023-24 Fire Season (%)";
    if (element === "gfa_nFRk")
      return "Number of Fires Rank in 2023-24 Fire Season";
    return element;
  });
  // console.log(newHeader)

  // Add keys to CSV as first row
  row = newHeader.join(",");
  csv += row + "\r\n";

  // Loop through each feature, extract values and add to csv
  for (let i = 0; i < activeLayer().features.length; i++) {
    let line = "";
    for (let j = 0; j < keysHeader.length; j++) {
      if (line !== "") line += ",";

      // For region names, remove any commas that may be present
      let value = "";
      if (keysHeader[j] === "reg_name") {
        value = activeLayer().features[i].properties[keysHeader[j]].replace(
          ",",
          ""
        );
        // console.log(value)
      } else {
        value = activeLayer().features[i].properties[keysHeader[j]];
      }

      line += value;
    }

    csv += line + "\r\n";
  }
  // console.log(csv.split("\n")[0])

  // 2. Create a blob, configure it, create an object URL and pass the blob object into the object URL
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8," });

  // 3. Create temporary link to download in the browser
  const downloadLink = document.createElement("a");
  downloadLink.download = `${activeLayer().name}`;
  downloadLink.href = window.URL.createObjectURL(blob);
  downloadLink.style.display = "none"; // hide temporary link in browser

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}
